import { render, staticRenderFns } from "./AddPinBatch.vue?vue&type=template&id=3b64a44d&scoped=true"
import script from "./AddPinBatch.vue?vue&type=script&lang=js"
export * from "./AddPinBatch.vue?vue&type=script&lang=js"
import style0 from "./AddPinBatch.vue?vue&type=style&index=0&id=3b64a44d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64a44d",
  null
  
)

export default component.exports